import dayjs from "dayjs";
import { useEffect, useRef } from "react";

import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import { fullReset } from "@/store/actions";
import { setLoggedInAt } from "@/store/slices/user";

export const useDailyResetEffect = () => {
    const loggedInAt = useAppSelector((s) => s.user.loggedInAt);

    const dispatch = useAppDispatch();
    const initialLoggedInAtRef = useRef(loggedInAt);

    useEffect(() => {
        const now = dayjs();
        const initialLoggedInAt = initialLoggedInAtRef.current;
        const isValid =
            !!initialLoggedInAt && dayjs(initialLoggedInAt).isValid();
        const isToday = isValid && dayjs(initialLoggedInAt).isSame(now, "day");

        if (isValid && !isToday) {
            dispatch(setLoggedInAt(now.toISOString()));
            dispatch(fullReset());

            return;
        }

        dispatch(setLoggedInAt(now.toISOString()));
    }, [dispatch]);
};
